import { useCallback, useState } from "react";
import useGetLinkedEquipmentInspections from "./useGetLinkedEquipmentInspections";
import { useEquipmentStore } from "../../store/equipment";
import useGetInspection from "../work-order/inspection/useGetInspection";
import useGetTestEquipmentListAndRule from "../work-order/inspection/useGetTestEquipmentListAndRule";

export default function useDownloadEquipmentInspections() {
  const [isDownloading, setIsDownloading] = useState(false);
  const { getLinkedInspections } = useGetLinkedEquipmentInspections();
  const { getInspection } = useGetInspection();
  const { getTestEquipmentListAndRule } = useGetTestEquipmentListAndRule();

  const downloadAllLinkedInspections = useCallback(
    async (equipId: string) => {
      const linkedInspections =
        useEquipmentStore.getState().getInspectionsForEquipment(equipId) ?? [];
      for (const ins of linkedInspections) {
        await getInspection(equipId, ins.InspectionId.toString(), {
          isEquipmentContext: true,
          equipmentId: equipId,
        });
      }
    },
    [getInspection]
  );

  const trigger = useCallback(
    async (ids: string[]) => {
      setIsDownloading(true);
      for (const id of ids) {
        await getLinkedInspections(id);
        await downloadAllLinkedInspections(id);
      }
      await getTestEquipmentListAndRule();
      setIsDownloading(false);
    },
    [
      downloadAllLinkedInspections,
      getLinkedInspections,
      getTestEquipmentListAndRule,
    ]
  );

  return {
    trigger,
    isDownloading,
  };
}
